import React, { Component } from 'react';
import ActionMenu from '../utils/ActionMenu';
import { withRouter  } from 'react-router-dom';
import { roleId } from '../../constants/app';

class TableSource extends Component {    
    handleDoubleClick = (item) => () => {
        if(this.props.role === roleId.admin )
            this.props.history.push(`/handbook/sources/edit/${+item.id}`)
    }
    
    renderBody() {        
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map(item => {
                        const actions = [
                            { access: roleId.admin, name: 'Редактирование', icon: 'flaticon2-contract', action: () => this.props.history.push(`/handbook/sources/edit/${+item.id}`) },
                            { access: roleId.admin, name: 'Комиссии', icon: 'flaticon-coins', action: () => this.props.history.push(`/handbook/sources/commissions/${+item.id}`)},
                            { access: roleId.admin, name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item)},
                        ].filter(item => !item.access || item.access === this.props.role);
                        return (
                            <tr onDoubleClick={this.handleDoubleClick(item)} key={item.id} className="kt-datatable__row">
                            
                            <td className="kt-datatable__cell" style={{ width: 'auto' }}>
                                <span>
                                    {item.name}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '25%' }}>
                                <span>
                                    {item.value}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '50px' }}>
                                <span className='client_table-info status'>
                                    {item.isAggregator 
                                    ? <span style={{ verticalAlign: 'middle' }} className="kt-badge kt-badge--warning kt-badge--inline">Агрегатор</span>
                                    : <span style={{ verticalAlign: 'middle' }} className="kt-badge kt-badge--brand kt-badge--inline">Источник</span>}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                <ActionMenu actions={actions}/>
                            </td>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    renderBodyMobile(){
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map(item => {
                        const actions = [
                            { access: roleId.admin, name: 'Редактирование', icon: 'flaticon2-contract', action: () => this.props.history.push(`/handbook/payments/edit/${+item.id}`) },
                            { access: roleId.admin, name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item)}
                        ].filter(item => !item.access || item.access === this.props.role);
                        return (
                            <tr onDoubleClick={this.handleDoubleClick(item)} key={item.id} className="kt-datatable__row">
                            <div className='mobile_div_flex column padding10px'>
                                <div className='mobile_div_flex gap0px' style={{ height: 'auto' }}>
                                    {item.isAggregator 
                                    ? <span style={{ verticalAlign: 'middle' }} className="kt-badge kt-badge--warning kt-badge--inline">Агрегатор</span>
                                    : <span style={{ verticalAlign: 'middle' }} className="kt-badge kt-badge--brand kt-badge--inline">Источник</span>}
                                </div>
                                <div className='mobile_div_flex gap0px'>
                                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                                        <span>
                                            {item.name}
                                        </span>
                                    </div>
                                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                                        <span>
                                            {item.value}
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex gap0px'>
                                    <div className='mobile_div_flex' style={{ width: 'calc(50% - 5px)' }}>
                                    </div>
                                    <div className='mobile_div_flex' style={{ width: '50%', justifyContent: 'flex-start' }}>
                                        <span>
                                            <ActionMenu actions={actions}/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return (
                <div>Источники не найдены</div>
            );
        }

        if(window.innerWidth < 500)
            return (
                <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                    {this.renderBodyMobile()}
                </table>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderBody()}
            </table>
        );
    }
}

export default withRouter(TableSource);